export default __webpack_public_path__ + "static/media/trash.dda47fe6.png";